<section class="md-page">
  <p-toast></p-toast>
  <p-confirmDialog [style]="{ width: '450px' }"></p-confirmDialog>

  <div class="md-list-shell">
    <div class="flex align-items-center justify-content-between mb-3">
      <h2 class="m-0">Users</h2>
      <div class="flex gap-2">
        <p-button label="New User" icon="pi pi-plus" (onClick)="createUser()"></p-button>
        <p-button label="Export" icon="pi pi-file-excel" styleClass="p-button-help" (click)="exportExcel()"></p-button>
      </div>
    </div>

    <div class="mb-4 p-4 border-round-2xl bg-gray-100">
      <form [formGroup]="filterForm" (ngSubmit)="onSearch()">
        <div class="grid formgrid p-fluid">
          <div class="field col-12 md:col-6 lg:col-4">
            <p-inputgroup>
              <p-inputgroup-addon><i class="pi pi-user"></i></p-inputgroup-addon>
              <p-iftalabel>
                <input pInputText formControlName="fullName" id="fullNameFilter" class="w-full" />
                <label for="fullNameFilter">Full Name</label>
              </p-iftalabel>
            </p-inputgroup>
          </div>

          <div class="field col-12 md:col-6 lg:col-4">
            <p-inputgroup>
              <p-inputgroup-addon><i class="pi pi-envelope"></i></p-inputgroup-addon>
              <p-iftalabel>
                <input pInputText formControlName="email" id="emailFilter" class="w-full" />
                <label for="emailFilter">Email</label>
              </p-iftalabel>
            </p-inputgroup>
          </div>
        </div>

        <div class="flex justify-content-end gap-2 mt-4">
          <p-button label="Reset" icon="pi pi-refresh" styleClass="p-button-secondary" type="button" (onClick)="onReset()"></p-button>
          <p-button label="Search" icon="pi pi-search" type="submit"></p-button>
        </div>
      </form>
    </div>

    <p-table
      #dt
      [value]="users"
      [rows]="10"
      [paginator]="true"
      [totalRecords]="totalRecords"
      [loading]="isLoading"
      [lazy]="true"
      (onLazyLoad)="loadUsers($event)"
      dataKey="id"
      styleClass="p-datatable-striped md-data-table"
    >
      <ng-template pTemplate="header">
        <tr>
          <th pSortableColumn="fullName">
            Full Name <p-sortIcon field="fullName"></p-sortIcon>
          </th>
          <th>Email</th>
          <th>Status</th>
          <th style="width: 8rem">Actions</th>
        </tr>
      </ng-template>

      <ng-template pTemplate="body" let-user>
        <tr>
          <td>{{ user.fullName }}</td>
          <td>{{ user.email }}</td>
          <td>
            <p-tag [severity]="getStatusColor(user.status)">
              {{ user.status }}
            </p-tag>
          </td>
          <td>
            <div class="flex gap-2">
              <p-button
                icon="pi pi-eye"
                styleClass="p-button-rounded p-button-info p-button-outlined"
                (onClick)="viewProfile(user.id)"
              ></p-button>
              <p-button
                icon="pi pi-pencil"
                styleClass="p-button-rounded p-button-success"
                (onClick)="editUser(user.id)"
              ></p-button>
              <!-- <p-button icon="pi pi-trash" styleClass="p-button-rounded p-button-danger" (onClick)="deleteUser(user)"></p-button> -->
            </div>
          </td>
        </tr>
      </ng-template>
      
      <ng-template pTemplate="emptymessage">
        <tr>
          <td colspan="4">No users found.</td>
        </tr>
      </ng-template>
    </p-table>
  </div>
</section>
